module.exports = __webpack_public_path__ + "static/media/submission.5c81d785.svg";